<template lang="pug">
  #economicDep
    v-container.pl-0(fluid)
      v-row.py-1.delete-dependant
        v-btn(@click="deleteDependant()")
          v-icon clear
          | Eliminar
      v-col(xs=12 sm=12)
        v-row.py-1.justify-space-between
          v-col(d-flex xs=12 sm=4)
            v-text-field(
            	v-model="economicDependentName"
            	label="Nombre"
            )

          v-col(d-flex xs=12 sm=4)
            v-menu(
              v-model="economicDependentDatePickerMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
              max-width="290px"
            )
              template(
                v-slot:activator="{ on }"
              )
                v-text-field(
                  :value="formatDate(economicDependentBirthday)"
                  label="Fecha de nacimiento"
                  readonly
                  v-on="on"
                )
              v-date-picker(v-model="economicDependentBirthday" @input="economicDependentDatePickerMenu = false" color="grey lighten-2")

          v-col(d-flex xs=12 sm=4)
            label.custom.mb-2 Sexo
            v-radio-group(
            	v-model="economicDependentSex"
              row
            )
              v-radio(
              	:label="sex.name"
              	v-for="(sex, i) in sexes"
              	:key="sex.slug"
              	:value="i"
              )
        v-row.py-1.justify-space-between
          v-col(d-flex xs=12 sm=9)
            label.custom.mb-2 Relación con la víctima (la víctima es su..)
            v-radio-group(
            	v-model="economiDependentRelationship"
              row
            )
              v-radio(
              	v-for="(relationship, i) in relationships"
              	:key="relationship.slug"
              	:value="i"
              	:label="relationship.name"
              )
          v-col(d-flex xs=12 sm=3)
            v-text-field(
            	label="Especificar"
            	v-model="economicDependentOtherRelationship"
              :disabled= "!showEconomicDependentOtherRelationship"
            )

        v-row.py-1.justify-space-between
          v-col(d-flex xs=12 sm=2)
            label.custom.mb-2 ¿Actualmente estudia?
            v-radio-group(
            	v-model="economicDependentCurrentlyStudying"
              row
            )
              v-radio(
              	v-for="(directAnswer, i) in directAnswers"
              	:key="directAnswer.slug"
              	:value="i"
              	:label="directAnswer.name"
              )

          v-col(d-flex xs=12 sm=10)
            label.custom.mb-2 Nivel Educativo
            v-radio-group(
            	v-model="economicDependentCurrentEducationLevel"
              row
            )
              v-radio(
              	v-for="(educationLevel, i) in educationLevels"
              	:key="educationLevel.slug"
              	:value="i"
              	:label="educationLevel.name"
              )
        v-row.py-1
          v-col(d-flex xs=12 sm=3 v-if="showEconomicDependentEducationQuestions")
            v-text-field(
            	label="Nombre de la Escuela"
            	v-model="economicDependentSchoolName"
            )

          v-col(d-flex xs=12 sm=5)
            v-row
              v-col(d-flex xs=12 sm=7)
                v-row
                  label.custom.mb-2 ¿Actualmente se encuentra dado de alta como beneficiario en algún programa para apoyo de víctimas?
              v-col(d-flex xs=12 sm=5)
                v-radio-group(
                	v-model="economicDependentIsVictimSupportBeneficiary"
                  row
                )
                  v-radio(
                  	v-for="(directAnswer, i) in directAnswers"
                  	:key="directAnswer.slug"
                  	:value="i"
                  	:label="directAnswer.name"
                  )
          v-col(d-flex xs=12 sm=4  v-if="showEconomicDependentWhichSupportProgram")
            v-row
              v-col(d-flex xs=12 sm=5)
                v-row
                  label.custom.mb-2 ¿En qué programa de apoyo se encuentra registrado?
              v-col(d-flex xs=12 sm=7)
                .program-container(v-for="(supportProgram, i) in supportPrograms" :key="supportProgram.slug")
                  v-checkbox(
                    v-model="economicDependentWhichSupportProgram"
                    :value="supportProgram.name"
                  	:label="supportProgram.name"
                    color="#4361ee"
                    row
                  )

        v-row.py-1
          v-col(d-flex xs=12 sm=2 v-if="showEconomicDependentReceiveFanvi")
            label.custom.mb-2 ¿Reciben Apoyos de FANVI?
            v-radio-group(
            	v-model="economicDependentReceiveFanvi"
              row
            )
              v-radio(
              	v-for="(directAnswer, i) in directAnswers"
              	:key="directAnswer.slug"
              	:value="i"
              	:label="directAnswer.name"
              )

          v-col(d-flex xs=12 sm=8 v-if="showEconomicDependentFanviSupport")
            label.custom.mb-2 ¿Qué recibe de FANVI?
            v-row
              .fanviSpt-container.mr-2(v-for="FanviSupport in FanviSupports" :key="FanviSupport.slug")
                v-checkbox(
                  v-model="economicDependentFanviSupport"
                  :value="FanviSupport.slug"
                	:label="FanviSupport.name"
                  color="#4361ee"
                  row
                )

          v-col(d-flex xs=12 sm=2 v-if="showEconomicDependentFanviSupport")
            v-text-field(
            	v-model="economicDependentOtherFanviSupport"
            	label="Especificar"
              :disabled="!showEconomicDependentOtherFanviSupport"
            )
        v-row
          v-col(d-flex xs=12 sm=5 v-if="showEconomicDependentProblemsReceivingSupport")
            v-row
              label.custom.mb-2 ¿Existen dificultades para recibir estos apoyos?
            v-row
              v-col(d-flex xs=12 sm=5)
                v-radio-group(
                	v-model="economicDependentProblemsReceivingSupport"
                  row
                )
                  v-radio(
                  	v-for="(directAnswer, i) in directAnswers"
                  	:key="directAnswer.slug"
                  	:value="i"
                  	:label="directAnswer.name"
                  )

              v-col(d-flex xs=12 sm=7)
                v-text-field(
                	v-model="economicDependentOtherProblemsReceivingSupport"
                	label="Especificar"
                  :disabled= "!!economicDependentProblemsReceivingSupport"
                )

          v-col(d-flex xs=12 sm=5)
            v-row
              label.custom.mb-2 ¿Cuenta con algún otro apoyo educativo?
            v-row
              v-col(d-flex xs=12 sm=5)
                v-radio-group(
                	v-model="economicDependentEducationalSupport"
                  row
                )
                  v-radio(
                  	v-for="(directAnswer, i) in directAnswers"
                  	:key="directAnswer.slug"
                  	:value="i"
                  	:label="directAnswer.name"
                  )

              v-col(d-flex xs=12 sm=7 )
                v-text-field(
                	v-model="economicDependentOtherEducationalSupport"
                	label="Especificar"
                  :disabled= "!!economicDependentEducationalSupport"
                )

          v-col(d-flex xs=12 sm=2)
            label.custom.mb-2 ¿Cuenta con servicio médico?
            v-radio-group(
            	v-model="economicDependentHasMedicalService"
              row
            )
              v-radio(
              	v-for="(directAnswer, i) in directAnswers"
              	:key="directAnswer.slug"
              	:value="i"
              	:label="directAnswer.name"
              )

        v-row.py-1(v-if="showEconomicDependentMedicalServiceProvider")
          v-col(d-flex xs=12 sm=6 )
            label.custom.mb-2 ¿Con cuál?
            v-radio-group(
            	v-model="economicDependentMedicalServiceProvider"
              row
            )
              v-radio(
              	v-for="(medicalServiceProvider, i) in medicalServiceProviders"
              	:key="medicalServiceProvider.slug"
              	:value="i"
              	:label="medicalServiceProvider.name"
              )

          v-col(d-flex xs=12 sm=3)
            v-text-field(
            	v-model="economicDependentOtherMedicalService"
            	label="Especificar"
              :disabled="!showEconomicDependentOtherMedicalService"
            )

          v-col(d-flex xs=12 sm=3 v-if="showEconomicDependentMedicalServiceNumber")
            v-text-field(
            	v-model="economicDependentMedicalServiceNumber"
            	label="Número de servicio médico"
            )


</template>

<script>
import * as _ from "lodash";

export default {
  name: "EconomicDependent",
  props: ["economicDependentIndex"],
  data() {
    return {
      economicDependentDatePickerMenu: false,
      // Catalogs
      relationships: [
        { name: "Hijo", slug: "son" },
        { name: "Hija", slug: "daughter" },
        { name: "Esposa", slug: "wife" },
        { name: "Esposo", slug: "husband" },
        { name: "Mamá", slug: "mom" },
        { name: "Papá", slug: "dad" },
        { name: "Hermana", slug: "sister" },
        { name: "Hermano", slug: "brother" },
        { name: "Abuela", slug: "grandma" },
        { name: "Abuelo", slug: "grandpa" },
        { name: "Otro", slug: "other" }
      ],
      supportPrograms: [
        { name: "FUD", slug: "fud" },
        { name: "FANVI", slug: "fanvi" }
      ],
      supportProgramSelection: [],
      FanviSupports: [
        { name: "Uniforme", slug: "uniform" },
        { name: "Zapatos", slug: "shoes" },
        { name: "Tarjeta de despensa", slug: "pantryCard" },
        { name: "Carta condenatoria", slug: "condemnatoryLetter" },
        { name: "Otro", slug: "other" }
      ],
      // Toggle Flags
      showEconomicDependentOtherRelationship: false,
      showEconomicDependentEducationQuestions: false,
      showEconomicDependentWhichSupportProgram: false,
      showEconomicDependentProblemsReceivingSupport: false,
      showEconomicDependentReceiveFanvi: false,
      showEconomicDependentFanviSupport: false,
      showEconomicDependentOtherFanviSupport: false,
      showEconomicDependentOtherProblemsReceivingSupport: false,
      showEconomicDependentOtherEducationalSupport: false,
      showEconomicDependentMedicalServiceProvider: false,
      showEconomicDependentOtherMedicalService: false,
      showEconomicDependentMedicalServiceNumber: false
    };
  },
  computed: {
    directAnswers() {
      return this.$store.state.directAnswers;
    },
    sexes() {
      return this.$store.state.sexes;
    },
    medicalServiceProviders() {
      return this.$store.state.medicalServiceProviders;
    },
    educationLevels() {
      return this.$store.state.educationLevels;
    },
    economicDependentName: {
      get() {
        return this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].name;
      },
      set(value) {
        this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].name = value;
      }
    },
    economicDependentBirthday: {
      get() {
        return this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].birthday;
      },
      set(value) {
        this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].birthday = value;
      }
    },
    economicDependentSex: {
      get() {
        return this.sexes.findIndex(
          sex =>
            sex.slug ==
            this.$store.state.record.socioec.economicDependents[
              this.economicDependentIndex
            ].sex.slug
        );
      },
      set(index) {
        this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].sex = this.sexes[index];
      }
    },
    economiDependentRelationship: {
      get() {
        var storedValSlug = this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].relationship.slug;

        var variableRelationship = {
          flagVar: "showEconomicDependentOtherRelationship",
          relatedVar: `$store.state.record.socioec.economicDependents[${this.economicDependentIndex}].otherRelationship`,
          defaultValueRelatedVar: ""
        };

        if (storedValSlug == "other") {
          variableRelationship.conditionSuccess = true;
        } else {
          variableRelationship.conditionSuccess = false;
        }
        this.toggleRelatedFlags(variableRelationship);

        return this.relationships.findIndex(
          relationship =>
            relationship.slug ==
            this.$store.state.record.socioec.economicDependents[
              this.economicDependentIndex
            ].relationship.slug
        );
      },
      set(index) {
        this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].relationship = this.relationships[index];
      }
    },
    economicDependentOtherRelationship: {
      get() {
        return this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].otherRelationship;
      },
      set(value) {
        this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].otherRelationship = value;
      }
    },
    economicDependentCurrentlyStudying: {
      get() {
        var storedValSlug = this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].education.currentlyStudying.slug;

        var variableRelationship = {
          flagVar: "showEconomicDependentEducationQuestions",
          relatedVar: `$store.state.record.socioec.economicDependents[${this.economicDependentIndex}].education.currentEducationLevel`,
          defaultValueRelatedVar: {}
        };
        var secondVariableRelationship = {
          flagVar: "showEconomicDependentEducationQuestions",
          relatedVar: `$store.state.record.socioec.economicDependents[${this.economicDependentIndex}].education.schoolName`,
          defaultValueRelatedVar: ""
        };

        if (storedValSlug == "yes") {
          variableRelationship.conditionSuccess = true;
          secondVariableRelationship.conditionSuccess = true;
        } else {
          variableRelationship.conditionSuccess = false;
          secondVariableRelationship.conditionSuccess = false;
        }
        this.toggleRelatedFlags(variableRelationship);
        this.toggleRelatedFlags(secondVariableRelationship);

        return this.directAnswers.findIndex(
          directAnswer =>
            directAnswer.slug ==
            this.$store.state.record.socioec.economicDependents[
              this.economicDependentIndex
            ].education.currentlyStudying.slug
        );
      },
      set(index) {
        this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].education.currentlyStudying = this.directAnswers[index];
      }
    },
    economicDependentCurrentEducationLevel: {
      get() {
        return this.educationLevels.findIndex(
          educationLevel =>
            educationLevel.slug ==
            this.$store.state.record.socioec.economicDependents[
              this.economicDependentIndex
            ].education.currentEducationLevel.slug
        );
      },
      set(index) {
        this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].education.currentEducationLevel = this.educationLevels[index];
      }
    },
    economicDependentSchoolName: {
      get() {
        return this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].education.schoolName;
      },
      set(value) {
        this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].education.schoolName = value;
      }
    },
    economicDependentIsVictimSupportBeneficiary: {
      get() {
        var storedValSlug = this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].supportProgram.isBeneficiary.slug;

        var variableRelationship = {
          flagVar: "showEconomicDependentWhichSupportProgram",
          relatedVar: `$store.state.record.socioec.economicDependents[${this.economicDependentIndex}].supportProgram.whichSupportProgram`,
          defaultValueRelatedVar: {}
        };

        var secondVariableRelationship = {
          flagVar: "showEconomicDependentProblemsReceivingSupport",
          relatedVar: `$store.state.record.socioec.economicDependents[${this.economicDependentIndex}].supportProgram.problemsReceivingSupport`,
          defaultValueRelatedVar: {}
        };

        if (storedValSlug == "yes") {
          variableRelationship.conditionSuccess = true;
          secondVariableRelationship.conditionSuccess = true;
        } else {
          variableRelationship.conditionSuccess = false;
          secondVariableRelationship.conditionSuccess = false;
        }
        this.toggleRelatedFlags(variableRelationship);
        this.toggleRelatedFlags(secondVariableRelationship);

        return this.directAnswers.findIndex(
          directAnswer =>
            directAnswer.slug ==
            this.$store.state.record.socioec.economicDependents[
              this.economicDependentIndex
            ].supportProgram.isBeneficiary.slug
        );
      },
      set(index) {
        this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].supportProgram.isBeneficiary = this.directAnswers[index];
      }
    },
    economicDependentWhichSupportProgram: {
      get() {
        let storedValSlug = this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].supportProgram.whichSupportProgram;

        let variableRelationship = {
          flagVar: "showEconomicDependentReceiveFanvi",
          relatedVar: `$store.state.record.socioec.economicDependents[${this.economicDependentIndex}].supportProgram.FANVI.isBeneficiary`,
          defaultValueRelatedVar: {}
        };

        if (Array.isArray(storedValSlug)) {
          variableRelationship.conditionSuccess = storedValSlug.includes(
            "FANVI"
          )
            ? true
            : false;

          this.toggleRelatedFlags(variableRelationship);

          return storedValSlug;
        }

        storedValSlug = storedValSlug.slug;

        variableRelationship.conditionSuccess =
          storedValSlug == "fanvi" ? true : false;

        this.toggleRelatedFlags(variableRelationship);

        return this.supportPrograms.findIndex(
          supportProgram =>
            supportProgram.slug ==
            this.$store.state.record.socioec.economicDependents[
              this.economicDependentIndex
            ].supportProgram.whichSupportProgram.slug
        );
      },
      set(value) {
        if (
          Array.isArray(
            this.$store.state.record.socioec.economicDependents[
              this.economicDependentIndex
            ].supportProgram.whichSupportProgram
          )
        ) {
          this.$store.state.record.socioec.economicDependents[
            this.economicDependentIndex
          ].supportProgram.whichSupportProgram = value;
        } else {
          let supportPrograms = [];
          supportPrograms.push(value);

          this.$store.state.record.socioec.economicDependents[
            this.economicDependentIndex
          ].supportProgram.whichSupportProgram = [...new Set(supportPrograms)];
        }
      }
    },
    economicDependentReceiveFanvi: {
      get() {
        var storedValSlug = this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].supportProgram.FANVI.isBeneficiary.slug;

        var variableRelationship = {
          flagVar: "showEconomicDependentFanviSupport",
          relatedVar: `$store.state.record.socioec.economicDependents[${this.economicDependentIndex}].supportProgram.FANVI.kindOfSupport`,
          defaultValueRelatedVar: {}
        };

        if (storedValSlug == "yes") {
          variableRelationship.conditionSuccess = true;
        } else {
          variableRelationship.conditionSuccess = false;
        }
        this.toggleRelatedFlags(variableRelationship);

        return this.directAnswers.findIndex(
          directAnswer =>
            directAnswer.slug ==
            this.$store.state.record.socioec.economicDependents[
              this.economicDependentIndex
            ].supportProgram.FANVI.isBeneficiary.slug
        );
      },
      set(index) {
        this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].supportProgram.FANVI.isBeneficiary = this.directAnswers[index];
      }
    },
    economicDependentFanviSupport: {
      get() {
        let storedValSlug = this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].supportProgram.FANVI.kindOfSupport;

        let variableRelationship = {
          flagVar: "showEconomicDependentOtherFanviSupport",
          relatedVar: `$store.state.record.socioec.economicDependents[${this.economicDependentIndex}].supportProgram.FANVI.otherKindOfSupport`,
          defaultValueRelatedVar: ""
        };

        if (Array.isArray(storedValSlug)) {
          variableRelationship.conditionSuccess = storedValSlug.includes(
            "other"
          )
            ? true
            : false;

          this.toggleRelatedFlags(variableRelationship);

          return storedValSlug;
        }

        storedValSlug = storedValSlug.slug;
        variableRelationship.conditionSuccess =
          storedValSlug == "other" ? true : false;
        this.toggleRelatedFlags(variableRelationship);

        return this.FanviSupports.findIndex(
          FanviSupport =>
            FanviSupport.slug ==
            this.$store.state.record.socioec.economicDependents[
              this.economicDependentIndex
            ].supportProgram.FANVI.kindOfSupport.slug
        );
      },
      set(value) {
        if (
          Array.isArray(
            this.$store.state.record.socioec.economicDependents[
              this.economicDependentIndex
            ].supportProgram.FANVI.kindOfSupport
          )
        ) {
          this.$store.state.record.socioec.economicDependents[
            this.economicDependentIndex
          ].supportProgram.FANVI.kindOfSupport = value;
        } else {
          let supports = [];
          supports.push(value);

          this.$store.state.record.socioec.economicDependents[
            this.economicDependentIndex
          ].supportProgram.FANVI.kindOfSupport = [...new Set(supports)];
        }
      }
    },
    economicDependentOtherFanviSupport: {
      get() {
        return this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].supportProgram.FANVI.otherKindOfSupport;
      },
      set(value) {
        this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].supportProgram.FANVI.otherKindOfSupport = value;
      }
    },
    economicDependentProblemsReceivingSupport: {
      get() {
        var storedValSlug = this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].supportProgram.problemsReceivingSupport.slug;

        var variableRelationship = {
          flagVar: "showEconomicDependentOtherProblemsReceivingSupport",
          relatedVar: `$store.state.record.socioec.economicDependents[${this.economicDependentIndex}].supportProgram.otherProblemsReceivingSupport`,
          defaultValueRelatedVar: ""
        };

        if (storedValSlug == "yes") {
          variableRelationship.conditionSuccess = true;
        } else {
          variableRelationship.conditionSuccess = false;
        }
        this.toggleRelatedFlags(variableRelationship);

        return this.directAnswers.findIndex(
          directAnswer =>
            directAnswer.slug ==
            this.$store.state.record.socioec.economicDependents[
              this.economicDependentIndex
            ].supportProgram.problemsReceivingSupport.slug
        );
      },
      set(index) {
        this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].supportProgram.problemsReceivingSupport = this.directAnswers[index];
      }
    },
    economicDependentOtherProblemsReceivingSupport: {
      get() {
        return this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].supportProgram.otherProblemsReceivingSupport;
      },
      set(value) {
        this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].supportProgram.otherProblemsReceivingSupport = value;
      }
    },
    economicDependentEducationalSupport: {
      get() {
        var storedValSlug = this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].supportProgram.educationalSupport.slug;

        var variableRelationship = {
          flagVar: "showEconomicDependentOtherEducationalSupport",
          relatedVar: `$store.state.record.socioec.economicDependents[${this.economicDependentIndex}].supportProgram.otherEducationalSupport`,
          defaultValueRelatedVar: ""
        };

        if (storedValSlug == "yes") {
          variableRelationship.conditionSuccess = true;
        } else {
          variableRelationship.conditionSuccess = false;
        }
        this.toggleRelatedFlags(variableRelationship);

        return this.directAnswers.findIndex(
          directAnswer =>
            directAnswer.slug ==
            this.$store.state.record.socioec.economicDependents[
              this.economicDependentIndex
            ].supportProgram.educationalSupport.slug
        );
      },
      set(index) {
        this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].supportProgram.educationalSupport = this.directAnswers[index];
      }
    },
    economicDependentOtherEducationalSupport: {
      get() {
        return this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].supportProgram.otherEducationalSupport;
      },
      set(value) {
        this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].supportProgram.otherEducationalSupport = value;
      }
    },
    economicDependentHasMedicalService: {
      get() {
        var storedValSlug = this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].medicalService.has.slug;

        var variableRelationship = {
          flagVar: "showEconomicDependentMedicalServiceProvider",
          relatedVar: `$store.state.record.socioec.economicDependents[${this.economicDependentIndex}].medicalService.provider`,
          defaultValueRelatedVar: {}
        };
        var secondVariableRelationship = {
          flagVar: "showEconomicDependentMedicalServiceNumber",
          relatedVar: `$store.state.record.socioec.economicDependents[${this.economicDependentIndex}].medicalService.number`,
          defaultValueRelatedVar: ""
        };

        if (storedValSlug == "yes") {
          variableRelationship.conditionSuccess = true;
          secondVariableRelationship.conditionSuccess = true;
        } else {
          variableRelationship.conditionSuccess = false;
          secondVariableRelationship.conditionSuccess = false;
        }
        this.toggleRelatedFlags(variableRelationship);
        this.toggleRelatedFlags(secondVariableRelationship);

        return this.directAnswers.findIndex(
          directAnswer =>
            directAnswer.slug ==
            this.$store.state.record.socioec.economicDependents[
              this.economicDependentIndex
            ].medicalService.has.slug
        );
      },
      set(index) {
        this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].medicalService.has = this.directAnswers[index];
      }
    },
    economicDependentMedicalServiceProvider: {
      get() {
        var storedValSlug = this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].medicalService.provider.slug;

        var variableRelationship = {
          flagVar: "showEconomicDependentOtherMedicalService",
          relatedVar: `$store.state.record.socioec.economicDependents[${this.economicDependentIndex}].medicalService.otherProvider`,
          defaultValueRelatedVar: ""
        };

        if (storedValSlug == "other") {
          variableRelationship.conditionSuccess = true;
        } else {
          variableRelationship.conditionSuccess = false;
        }
        this.toggleRelatedFlags(variableRelationship);

        return this.medicalServiceProviders.findIndex(
          medicalServiceProvider =>
            medicalServiceProvider.slug ==
            this.$store.state.record.socioec.economicDependents[
              this.economicDependentIndex
            ].medicalService.provider.slug
        );
      },
      set(index) {
        this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].medicalService.provider = this.medicalServiceProviders[index];
      }
    },
    economicDependentOtherMedicalService: {
      get() {
        return this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].medicalService.otherProvider;
      },
      set(value) {
        this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].medicalService.otherProvider = value;
      }
    },
    economicDependentMedicalServiceNumber: {
      get() {
        return this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].medicalService.number;
      },
      set(value) {
        this.$store.state.record.socioec.economicDependents[
          this.economicDependentIndex
        ].medicalService.number = value;
      }
    }
  },
  methods: {
    toggleRelatedFlags(params) {
      let {
        flagVar,
        relatedVar,
        defaultValueRelatedVar,
        conditionSuccess
      } = params;

      if (conditionSuccess) {
        _.set(this, flagVar, true);
      } else {
        _.set(this, flagVar, false);

        const tmpRelatedVar = relatedVar.split(".");

        if (tmpRelatedVar[0] == "$store" && tmpRelatedVar[1] == "state") {
          relatedVar = tmpRelatedVar.slice(2).join(".");
          _.set(this.$store.state, relatedVar, defaultValueRelatedVar);
        } else {
          _.set(this, relatedVar, defaultValueRelatedVar);
        }
      }
    },
    formatDate(value) {
      return value
        ? new Intl.DateTimeFormat("es").format(new Date(`${value}T00:00`))
        : "";
    },
    deleteDependant() {
      this.$store.state.record.socioec.economicDependents.splice(
        this.economicDependentIndex,
        1
      );
    }
  }
};
</script>

<style lang="scss" scoped>
#economicDep {
  width: 100%;
  .delete-dependant {
    display: flex;
    justify-content: flex-end;
    .v-btn {
      background-color: transparent;
      box-shadow: none;
      color: red;
      text-transform: none;
      font-size: 13px;
      i {
        font-size: 13px;
      }
    }
    .v-btn:before {
      background-color: transparent;
    }
  }
}
</style>
